import { render, staticRenderFns } from "./PupilAdd.vue?vue&type=template&id=7d4ca2f4&scoped=true&"
import script from "./PupilAdd.vue?vue&type=script&lang=js&"
export * from "./PupilAdd.vue?vue&type=script&lang=js&"
import style0 from "./PupilAdd.vue?vue&type=style&index=0&id=7d4ca2f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4ca2f4",
  null
  
)

export default component.exports